<template>
  <div class="bookingform-list">
    <h2>Sales List</h2>
    <button class="btn btn-primary mb-4" @click="addSale">Add New Sale</button>
    <SearchBox v-model="search" class="col-md-3 col-12" />
    <v-client-table
      :data="filteredSales"
      :columns="columns"
      :options="options"
      @row-click="showSale"
    ></v-client-table>
  </div>
</template>
  
  <script>
  import SearchBox from "@/components/tools/SearchBox.vue";
  const api = window.api;
  
  export default {
    name: "SalesList",
    components: {
      SearchBox,
    },
    data() {
      return {
        sales: [],
        search: "",
        columns: ["id", "Reference", "MainPassenger", "Consultant", "BookingAnalysis"],
        options: {
          headings: {
            Reference: "Reference",
            MainPassenger: "Main Passenger",
            Consultant: "Consultant",
            BookingAnalysis: "Booking Analysis",
          },
          sortable: ["id", "RefCode", "MainPassenger", "Consultant", "BookingAnalysis"],
          filterable: ["id", "RefCode", "MainPassenger", "Consultant", "BookingAnalysis"],
          perPage: 10,
          perPageValues: [10, 20, 50],
          skin: "table table-striped table-hover",
        },
      };
    },
    computed: {
      filteredSales() {
        if (!this.sales)  return []
        if (!this.search) return this.sales;
          
        const searchLower = this.search?.toLowerCase();
        return this.sales.filter((sale) => {
          return (
            sale.id?.toString().toLowerCase().includes(searchLower) ||
            sale.Reference?.toLowerCase().includes(searchLower) ||
            sale.MainPassenger?.toLowerCase().includes(searchLower) ||
            sale.Consultant?.toLowerCase().includes(searchLower) ||
            sale.BookingAnalysis?.toLowerCase().includes(searchLower)
          );
        });
      },
    },
    mounted() {
      this.fetchSales();
    },
    methods: {
      async fetchSales() {
        this.sales = await api.get("/api/sales/");
      },
      showSale(data) {
        this.$router.push({ name: "sale", params: { id: data.row.id } });
      },
      addSale() {
        this.$router.push({name: 'sale', params: {id: null}})
      },
    },
  };
  </script>
  
  <style scoped>
  .bookingform-list {
    margin: 20px;
  }
  .mb-4 {
    margin-bottom: 16px;
  }
  </style>
  